import * as z from "@-/com.npmjs.zod";
import { graphemeStrokeListSchema } from "#grapheme-stroke-slice";

export const graphemeSliceSchema = z.object({
  glyph: z.string(),
  strokes: graphemeStrokeListSchema,
});

export type GraphemeSlice = z.infer<typeof graphemeSliceSchema>;
